import NoConnectionIcon from "assets/icons/v2/NoConnectionIcon";
import LoadingSpinner from "assets/icons/v2/LoadingSpinner";
import InfoIcon from "assets/icons/v2/InfoIcon";
import FailedIcon from "assets/icons/v2/FailedIcon/FailedIcon";
import SuccessIcon from "assets/icons/v2/SuccessIcon/SuccessIcon";
import WarningIcon from "assets/icons/v2/WarningIcon";
import FailedIconWithBackground from "assets/icons/v2/FailedIcon/FailedIconWithBackground";
import SuccessIconWithBackground from "assets/icons/v2/SuccessIcon/SuccessIconWithBackground";

const Icons = {
  NoConnectionIcon,
  LoadingSpinner,
  InfoIcon,
  FailedIcon,
  SuccessIcon,
  WarningIcon,
  FailedIconWithBackground,
  SuccessIconWithBackground,
};
export default Icons;
